import styles from './Spinner.module.css';

export function Spinner({ size = 24, label = 'Loading', className = '' }) {
  return (
    <span
      className={`${styles.spinner} ${className}`}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label}
    />
  );
}
